module.exports = __webpack_public_path__ + "static/rule_bg.654dbc5e.png";